exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-dashboard{min-width:350px}.fts-dashboard .d-actions{padding:0 1rem;text-align:right}.fts-dashboard .d-container{display:flex;flex-wrap:wrap;padding:0 1rem}.fts-dashboard .d-container .d-wrapper{min-width:0;flex:1 1 350px}", ""]);

// exports
